import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { rightArrow, subMenuHome, subMenuPartners, subMenuProjects, whyUs } from '../../../assets/images';
import axios from 'axios';

const NewsItems = () => {
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;
  const [news, setNews] = useState([]);

  useEffect(() => {
    getProducts();
  }, []);

  const getProducts = async () => {
    try {
      const response = await axios.get(
        `https://cortex-site.runasp.net/api/Blogs`,
        { withCredentials: false }
      ); 
      setNews(response.data);
      console.log(response.data)
    } catch (error) {
      console.error("Error fetching products:", error);
    }
  };

  const getLocalizedField = (item, fieldBase) => {
    if (!item) return '';
    if (currentLanguage === 'en') return item[`${fieldBase}En`] || item[fieldBase];
    if (currentLanguage === 'ru') return item[`${fieldBase}Ru`] || item[fieldBase];
    return item[fieldBase]; // default: az
  };

  return (
    <div className='pt-[56px] md:pt-[88px] bg-[#F9F9F9] font-secondFont'>
      <div className='max-w-containerSm md:max-w-container mx-auto grid grid-cols-1 md:grid-cols-4 gap-x-5 gap-y-8'>
        {news.map((item) => (
          <a key={item.id} href={`/${currentLanguage}/blogs/${item.id}`}>
            <div className='group overflow-hidden rounded-lg'>
              <div className="relative">
                <img src={`https://cortex-site.runasp.net/${item.image}`} className='w-full transition-transform duration-300 group-hover:scale-105' alt='' />
                {/* <span className='absolute top-3 right-3 text-[#2a3d63] bg-[#F6FAFA] text-[12px] h-[21px] w-[83px] rounded-[12px] text-center flex items-center justify-center'>
                  {item.date}
                </span> */}
              </div>
              <p className='mt-3 text-[#1C1C1C]'>
                {getLocalizedField(item, "title")?.replace(/<[^>]*>/g, '').slice(0, 80)}...
              </p>
            </div>
          </a>
        ))}
      </div>
    </div>
  );
};

export default NewsItems;
